import { useMemo } from 'react';
import { StyledSocialLink, StyledSocialContainer, StyledWrapper } from './page-share.styles';
import { SocialIconLinks, PageShareProps } from './page-share.types';
import { socialIconLinks } from './page-share.constants';
export const PageShare = ({
  description,
  url,
  socialLinks,
  campaign = {}
}: PageShareProps): JSX.Element => {
  const filteredLinks: SocialIconLinks[] = useMemo(() => socialIconLinks.filter(lnk => socialLinks[lnk.name]), [socialLinks]);
  return <StyledWrapper data-sentry-element="StyledWrapper" data-sentry-component="PageShare" data-sentry-source-file="page-share.tsx">
      <StyledSocialContainer data-sentry-element="StyledSocialContainer" data-sentry-source-file="page-share.tsx">
        {filteredLinks.map(social => <StyledSocialLink data-social={social.name} href={social.href({
        description,
        url,
        campaign
      })} target="_blank" aria-label={description} key={social.name}>
            <social.icon />
          </StyledSocialLink>)}
      </StyledSocialContainer>
    </StyledWrapper>;
};